export default [
  {
    // collapse: true,
    // name: 'Sách điện tử (offline)',
    // // href: 'https://cdn.sachso.edu.vn/ebooks-offline/SachSoOffline.zip',
    // icon: 'fas fa-book text-yellow',
    // roles: ['student'],
    // sortOrder: 8,
    // showInSidebar: true,
    // state: 'lms/ebooks-offline',
    // views: [
    //   {
    //     path: '/ebooks-offline',
    //     layout: '/lms',
    //     exact: true,
    //     roles: ['authenticated'],
    //   },
    //   {
    //     // path: '/ebooks-offline/dictionary',
    //     name: 'Phiên bản dành cho Windows 7',
    //     miniName: 'D',
    //     href: 'https://cdn.sachso.edu.vn/ebooks-offline/SachSoOffline.exe',
    //     icon: <i className='fab fa-windows' style={{ color: '#21a7ff' }}></i>,
    //     // layout: '/lms',
    //     // exact: true,
    //     // roles: ['authenticated'],
    //     showInSidebar: true,
    //     sortOrder: 0,
    //     download: 1,
    //   },
    //   {
    //     // path: '/ebooks-offline/translate',
    //     name: 'Phiên bản dành cho Windows 10',
    //     miniName: 'D',
    //     href: 'https://cdn.sachso.edu.vn/ebooks-offline/win10/SachSoOffline.exe',
    //     icon: <i className='fab fa-windows' style={{ color: '#21a7ff' }}></i>,
    //     // layout: '/lms',
    //     // exact: true,
    //     // roles: ['authenticated'],
    //     showInSidebar: true,
    //     sortOrder: 1,
    //     download: 2,
    //   },
    // ],
  },
];
